"use client";
import Link from "next/link";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import testimonial_data from "@/data/PortfolioData";

import shape1 from "@/assets/img/portfolio/shape-3.png";
import { Icon } from "@/svg/Icon";

const MusePortfolioArea = () => {
  // 3d slider
  const [activeIndex, setActiveIndex] = useState<number>(2);

  useEffect(() => {
    const tp3dSlideWrapper = document.getElementById("tp-3d-slide-wrapper");
    if (!tp3dSlideWrapper) return;

    const dir = document.documentElement.getAttribute("dir");
    let startX = 0;
    let endX = 0;

    const handleTouchStart = (event: TouchEvent) => {
      startX = event.touches[0].clientX;
    };

    const handleTouchEnd = (event: TouchEvent) => {
      endX = event.changedTouches[0].clientX;
      handleSwipe();
    };

    const handleSwipe = () => {
      const deltaX = endX - startX;
      const sensitivity = 50; // Adjust this value based on your desired sensitivity

      if (Math.abs(deltaX) > sensitivity) {
        if ((dir === "rtl" && deltaX < 0) || (dir !== "rtl" && deltaX > 0)) {
          setActiveIndex(
            (prev) => (prev + numberOfSlides - 1) % numberOfSlides
          );
        } else {
          setActiveIndex(
            (prev) => (prev + numberOfSlides + 1) % numberOfSlides
          );
        }
      }
    };

    tp3dSlideWrapper.addEventListener("touchstart", handleTouchStart);
    tp3dSlideWrapper.addEventListener("touchend", handleTouchEnd);

    const numberOfSlides = document.querySelectorAll(".tp-3d-slide").length;

    const handleArrowClick = (direction: "left" | "right") => {
      const nextIndex =
        (activeIndex + numberOfSlides + (direction === "left" ? -1 : 1)) %
        numberOfSlides;

      if (nextIndex >= 0 && nextIndex < numberOfSlides) {
        setActiveIndex(nextIndex);
      }
    };

    const handleDotClick = (index: number) => {
      if (index >= 0 && index < numberOfSlides) {
        setActiveIndex(index);
      }
    };

    const updateSlides = () => {
      const slides = document.querySelectorAll(".tp-3d-slide");

      const prev1 = (activeIndex + numberOfSlides - 1) % numberOfSlides;
      const prev2 = (activeIndex + numberOfSlides - 2) % numberOfSlides;
      const next1 = (activeIndex + 1) % numberOfSlides;
      const next2 = (activeIndex + 2) % numberOfSlides;

      slides.forEach((slide, index) => {
        const classes = ["prev-1", "prev-2", "active", "next-1", "next-2"];
        slide.classList.remove(...classes);

        if (index === activeIndex) {
          slide.classList.add("active");
        } else if (index === prev1) {
          slide.classList.add("prev-1");
        } else if (index === prev2) {
          slide.classList.add("prev-2");
        } else if (index === next1) {
          slide.classList.add("next-1");
        } else if (index === next2) {
          slide.classList.add("next-2");
        }
      });
    };

    const handleArrowClickWrapper = (
      event: React.MouseEvent<HTMLDivElement>
    ) => {
      const direction = event.currentTarget.classList.contains(
        "tp-3d-slide-arrow-left"
      )
        ? "left"
        : "right";
      handleArrowClick(direction as "left" | "right");
    };

    const handleDotClickWrapper = (index: number) => {
      handleDotClick(index);
    };

    document
      .querySelectorAll(".tp-3d-slide-arrow-right, .tp-3d-slide-arrow-left")
      .forEach((arrow) => {
        (arrow as HTMLDivElement).addEventListener(
          "click",
          handleArrowClickWrapper as any
        );
      });

    document.querySelectorAll(".dots span").forEach((dot, index) => {
      dot.addEventListener("click", () => handleDotClickWrapper(index));
    });

    updateSlides();

    return () => {
      tp3dSlideWrapper.removeEventListener("touchstart", handleTouchStart);
      tp3dSlideWrapper.removeEventListener("touchend", handleTouchEnd);
      document
        .querySelectorAll(".tp-3d-slide-arrow-right, .tp-3d-slide-arrow-left")
        .forEach((arrow) => {
          (arrow as HTMLDivElement).removeEventListener(
            "click",
            handleArrowClickWrapper as any
          );
        });
      document.querySelectorAll(".dots span").forEach((dot, index) => {
        dot.removeEventListener("click", () => handleDotClickWrapper(index));
      });
    };
  }, [activeIndex]);

  {
    /* <div class="include-bg" style="
    background-image: url(/_next/static/media/ZOE-zoe-academy.5b5b7149.png);
    
    width: 80%;
    height: 70%;
    position: absolute;
    bottom: 5%;
    right: 5%;
    border-radius: 5px;
    border: 5px solid black;
"></div> */
  }

  return (
    <section id="portfolio">
      <div className="container pt-10">
        <div className="row ">
          <div className="col-xl-12">
            <div
              className="tp-section-subtitle"
              style={{ textAlign: "center" }}
            >
              Portfolio
            </div>
          </div>
        </div>
      </div>
      <div className="tp-portfolio-area d-flex align-items-center justify-content-start p-relative z-index-1 fix">
        <div className="tp-portfolio-shape">
          <Image
            className="tp-portfolio-shape-2-1 tp-zoom-in-out"
            src={shape1}
            alt="image-here"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-3d-slide-container">
                <span className="tp-3d-slide-arrow tp-3d-slide-arrow-left z-index-9">
                  <Icon name="HomeTwoPortfolioLeftArrow" />
                </span>

                <span className="tp-3d-slide-arrow tp-3d-slide-arrow-right z-index-9">
                  <Icon name="HomeTwoPortfolioRightArrow" />
                </span>

                <div className="tp-3d-slide-wrapper" id="tp-3d-slide-wrapper">
                  {testimonial_data.map((item, index) => (
                    <div
                      key={index}
                      className="tp-3d-slide tp-hover-reveal-text"
                    >
                      <a
                        href={item.url}
                        target={item.url === "#" ? "" : "_blank"}
                        className="tp-portfolio-item-2 include-bg"
                        style={{
                          backgroundImage: `linear-gradient(to bottom, #333c, #333c 30%, #fff0), url(${item.image.src})`,
                          ...item.style,
                        }}
                        onClick={(event) => {
                          if (item.url === "#") {
                            event.preventDefault();
                          }
                        }}
                      >
                        <div className="tp-portfolio-meta-2">
                          {item.tags.map((tag, i) => (
                            <span key={i}>{tag}</span>
                          ))}
                        </div>
                        <h3 className="tp-portfolio-title-2">{item.title}</h3>
                        <p className="tp-portfolio-summary-2">
                          {item.description}
                        </p>
                        {/* <div className="tp-portfolio-view tp-portfolio-view-btn">
                            <span>{item.ctaText}</span>
                          </div> */}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MusePortfolioArea;
